import { useEffect } from 'react';
import { toast } from 'react-toastify';

import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { isDeliveryDisposition, isValidValue, isSupportedTenantCode } from 'common/utilities/utils';
import { isDeliveryOrderPickedUpOrOutForOrArrived } from 'common/utilities/orderStatusUtils';
import { checkOrderSummaryModelOpen } from 'common/utilities/orderDetailsUtils';

const getOrderSummaryViews = props => {
  return <LazyLoaderWrapper {...props} testId='order_summary_view' importPath='ORDER_SUMMARY_VIEW'></LazyLoaderWrapper>;
};

const OrderSummaryViews = props => {
  const { orderDetails, updateSetOrderDetails } = props;
  const {
    orderSummarySaveYourOrderCompleted,
    service,
    orderStatus,
    enableRetryCountForPickupOrderTracking,
    displayOrderId,
  } = orderDetails;

  useEffect(() => {
    if (isValidValue(service)) {
      if (isSupportedTenantCode()) {
        updateSetOrderDetails({ orderSummaryInfoDetailsShowInAccordion: true, pickupClosingSoonModal: true });
      } else {
        updateSetOrderDetails({ orderSummaryInfoDetailsShowInAccordion: isDeliveryDisposition(service) });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service]);

  useEffect(() => {
    isValidValue(orderStatus) &&
      updateSetOrderDetails({
        orderSummaryInfoDetailsOpenAccordion: enableRetryCountForPickupOrderTracking
          ? checkOrderSummaryModelOpen(orderDetails)
          : !isDeliveryOrderPickedUpOrOutForOrArrived(orderDetails),
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderStatus, displayOrderId]);

  useEffect(() => {
    if (orderSummarySaveYourOrderCompleted && !isSupportedTenantCode()) {
      toast.dark(
        <div className='img-text-div'>
          <span className={`notifyText notifyText-in`}>
            <img src={IMAGE_PATH?.SaveNotifyTick} alt='tick' className='TickImg' />
            {translateWithI18Next(TRANSLATE_MAPPING_KEY?.SAVED_THIS_ORDER_IN_MY_FAVORITE_MENU)}
          </span>
        </div>,
        {
          bodyClassName: 'toast-for-favorite',
          hideProgressBar: true,
          position: toast.POSITION.BOTTOM_CENTER,
        },
      );
      setTimeout(() => {
        toast.dismiss();
      }, 4000);
    }
  }, [orderSummarySaveYourOrderCompleted]);

  return getOrderSummaryViews(props);
};

export default OrderSummaryViews;
